export default "__VITE_ASSET__D_bGuR1r__"